"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelProtocolSerializer = void 0;
const AsciiControlCodes_1 = require("./AsciiControlCodes");
const ControlMessageSerializer_1 = require("./ControlMessageSerializer");
const SetPixelSerializer_1 = require("./SetPixelSerializer");
const SetTextMessageSerializer_1 = require("./SetTextMessageSerializer");
class PixelProtocolSerializer {
    constructor() {
        this._serializers = new Map();
        this._serializers.set("SetPixelsMessage", new SetPixelSerializer_1.SetPixelSerializer());
        this._serializers.set("SetTextMessage", new SetTextMessageSerializer_1.SetTextMessageSerializer());
        this._serializers.set("ControlMessage", new ControlMessageSerializer_1.ControlMessageSerializer());
    }
    serialize(message) {
        const serializer = this._serializers.get(message.constructor.name);
        return serializer.serialize(message);
    }
    deserialize(binary) {
        if (binary[0] !== AsciiControlCodes_1.AsciiControlCodes.DeviceControl1) {
            throw new Error("Message not supported, must be DeviceControl1");
        }
        if (binary[1] === AsciiControlCodes_1.AsciiControlCodes.P_PixelMode) {
            const serializer = this._serializers.get("SetPixelsMessage");
            return serializer.deserialize(binary);
        }
        if (binary[1] === AsciiControlCodes_1.AsciiControlCodes.T_TextMode) {
            const serializer = this._serializers.get("SetTextMessage");
            return serializer.deserialize(binary);
        }
        if (binary[1] === AsciiControlCodes_1.AsciiControlCodes.C_ControlMessage) {
            const serializer = this._serializers.get("ControlMessage");
            return serializer.deserialize(binary);
        }
        throw new Error("Only SetPixelMessage supported at this time.");
    }
}
exports.PixelProtocolSerializer = PixelProtocolSerializer;
//# sourceMappingURL=PixelProtocolSerializer.js.map